import { axios, base } from '../http';

export const getBugListPage = (params) => {
  return axios.get(`${base}/api/TopicDetail/get`, { params: params });
};

export const removeBug = (params) => {
  return axios.delete(`${base}/api/TopicDetail/delete`, { params: params });
};

export const editBug = (params) => {
  return axios.put(`${base}/api/TopicDetail/update`, params);
};

export const addBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/post`, params);
};

export const getBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog`, { params: params });
};

export const getBlogDeatil = (params) => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, { params: params });
};

export const editBlog = (params) => {
  return axios.put(`${base}/api/Blog/update`, params);
};

export const removeBlog = (params) => {
  return axios.delete(`${base}/api/Blog/delete`, { params: params });
};

// 日志

export const getLogs = (params) => {
  return axios.get(`${base}/api/Monitor/get`, { params: params });
};

export const getRequestApiinfoByWeek = (params) => {
  return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, {
    params: params,
  });
};

export const getAccessApiByDate = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, {
    params: params,
  });
};

export const getAccessApiByHour = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, {
    params: params,
  });
};

export const getServerInfo = (params) => {
  return axios.get(`${base}/api/Monitor/Server`, { params: params });
};

export const getAccessLogs = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, { params: params });
};

export const getIds4UsersGrow = (params) => {
  return axios.get(`${base}/api/Monitor/GetIds4Users`, { params: params });
};

export const getActiveUsers = (params) => {
  return axios.get(`${base}/api/Monitor/GetActiveUsers`, { params: params });
};

// Task管理

export const getTaskListPage = (params) => {
  return axios.get(`${base}/api/TasksQz/get`, { params: params });
};

export const removeTask = (params) => {
  return axios.delete(`${base}/api/TasksQz/delete`, { params: params });
};

export const editTask = (params) => {
  return axios.put(`${base}/api/TasksQz/put`, params);
};

export const addTask = (params) => {
  return axios.post(`${base}/api/TasksQz/post`, params);
};

export const startJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StartJob`, { params: params });
};

export const stopJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StopJob`, { params: params });
};

export const reCovery = (params) => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, { params: params });
};

export const pauseJob = (params) => {
  return axios.get(`${base}/api/TasksQz/PauseJob`, { params: params });
};

export const resumeJob = (params) => {
  return axios.get(`${base}/api/TasksQz/ResumeJob`, { params: params });
};

export const getTaskNameSpace = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskNameSpace`, { params: params });
};

export const GetTaskLogs = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskLogs`, { params: params });
};

export const GetTaskOverview = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskOverview`, { params: params });
};
// ids4
